var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-page"},[_c('error',{attrs:{"errors":_vm.errorMessage}}),_c('b-overlay',{attrs:{"show":_vm.menuBusy}},[_c('menu-form',{on:{"creating":_vm.handleCreating,"success":_vm.handleSuccess,"fail":_vm.handleFail,"loading":_vm.handleLoading,"loaded":_vm.handleLoaded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }